import React from "react";
import type { Stat } from "../../data/landingData";

export default function StatsStrip({ stats }: { stats: Stat[] }) {
    return (
        <section className="mx-auto max-w-6xl px-4 sm:px-6">
            <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur px-6 py-6">
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {stats.map((s) => (
                        <div key={s.label} className="space-y-1">
                            <div className="text-2xl font-semibold text-white">{s.value}</div>
                            <div className="text-sm text-white/70">{s.label}</div>
                            {s.sub ? <div className="text-xs text-white/50">{s.sub}</div> : null}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
